export const infomesTituloTxt = "Visualiza, descargá y compartí tus informes"